// extracted by mini-css-extract-plugin
module.exports = {"registration-tab":"_2TlXkART","registrationTab":"_2TlXkART","button-container":"_1aYEBoE6","buttonContainer":"_1aYEBoE6"};